<template>
    <div class="scheduled-email-listing">
        <template v-if="isScheduledEmailsFeatureEnabled">
            <TableLoading v-if="isLoading" />
            <template v-else>
                <EmailListingSettingsHeader
                    ref="ScheduledEmailsTable"
                    :columns="columns"
                    :totalEmails="formattedEmails.length"
                    class="scheduled-email-listing__settings-header"
                />
                <EmailListingTable
                    slot="table"
                    :columns="columns"
                    :emails="formattedEmails"
                    class="scheduled-email-listing__table"
                />
            </template>
        </template>
    </div>
</template>
<script>
import TableLoading from 'vcomponents/common/table/TableLoading.vue';
import EmailListingTable from 'vcomponents/email/listings/EmailListingTable.vue';
import EmailListingSettingsHeader from 'vcomponents/email/listings/EmailListingSettingsHeader.vue';
import Feature from 'Services/Feature';
import { getFilteredEmails, deleteEmailById } from 'api/emailEngine/emailEngineService';

export default {
    components: {
        EmailListingTable,
        EmailListingSettingsHeader,
        TableLoading,
    },
    events: {
        'delete:email': 'handleDelete',
    },
    data() {
        return {
            isLoading: true,
            activeTab: 'all',
            columns: [
                {
                    code: 'participants',
                    isDefault: true,
                    isMovable: false,
                    isVisible: true,
                    label: this.$t.__('email.ScheduledEmailListing.recipients'),
                    order: 0,
                    sortKey: 'participants',
                },
                // {
                //     code: 'linkedObjects',
                //     isDefault: true,
                //     isMovable: false,
                //     isVisible: true,
                //     label: this.$t.__('email.ScheduledEmailListing.linked_objects'),
                //     order: 1,
                //     sortKey: 'linkedObjects',
                // },
                {
                    code: 'subject',
                    isDefault: true,
                    isMovable: false,
                    isVisible: true,
                    label: this.$t.__('email.ScheduledEmailListing.subject'),
                    order: 2,
                    sortKey: 'subject',
                },
                {
                    code: 'scheduled_at',
                    isDefault: true,
                    isMovable: false,
                    isVisible: true,
                    label: this.$t.__('email.ScheduledEmailListing.scheduled_date'),
                    order: 3,
                    sortKey: 'scheduled_at',
                },
            ],
            emails: [],
        };
    },
    computed: {
        isScheduledEmailsFeatureEnabled() {
            return Feature.isEnabled('email-engine-scheduled-emails');
        },
        formattedEmails() {
            return this.emails.map((email) => {
                return {
                    ...email,
                    participants: email.to.concat(email.cc).concat(email.bcc),
                };
            });
        },
    },
    created() {
        this.getScheduledEmails();
    },
    methods: {
        // eslint-disable-next-line vue/no-unused-properties
        handleDelete($event) {
            deleteEmailById($event.params[0].id)
                .then(() => {
                    this.$pushToast({
                        close: true,
                        text: this.$t.__('email.ScheduledEmailListing.email_deleted'),
                        type: 'success',
                    });
                    this.getScheduledEmails($event.params[0].id);
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                });
        },
        getScheduledEmails(emailToExclude) {
            this.isLoading = true;
            getFilteredEmails(['scheduled'])
                .then((emails) => {
                    this.emails = emails.data.filter((email) => email.id !== emailToExclude);
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.scheduled-email-listing {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    border-radius: var(--spacing-0);
    padding: 0 var(--spacing-3);
    background: var(--colors-common-background-default);

    &__settings-header {
        align-items: center; // to be removed when filters are added to the header
        min-height: 64px;
    }

    &__table {
        padding: 0 0 var(--spacing-2);
        overflow: auto;
    }
}
</style>
